import { Component, Input, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { DisplayTicketWithControl } from "../shopping-cart-event-list.component"

@Component({
	selector: 'event-list-item-line-editable',
	templateUrl: "./item-line.presentation.html",
	styles: [require("./item-line.presentation.scss")]
})
export class EventListItemLineEditable {

	@Input() visualTickets: boolean
	@Input() visualBulkTickets: boolean
	@Input() displayTicketWithControl: DisplayTicketWithControl;
	@Output() removeTickets = new EventEmitter<string[]>();

	constructor(

	) { }
}



// WEBPACK FOOTER //
// ./src/app/components/shopping-cart/shopping-cart-event-list/editable/item-line.presentation.ts